import classNames from 'classnames/bind';
import React, { FunctionComponent } from 'react';

import { ITextProps, Text } from '../text/text';
import styles from './image-with-text.module.scss';

const cx = classNames.bind(styles);

export interface IImageWithTextProps {
  texts: ITextProps[];
  image: {
    url: string;
    description: string;
  };
  reversed: boolean;
}

export const ImageWithText: FunctionComponent<IImageWithTextProps> = props => {
  const { texts, image, reversed } = props;
  const sectionClasses = cx('section', { reversed });

  return (
    <section className={sectionClasses}>
      <div className={cx('imageContainer')}>
        <img src={image.url} className={styles.image} alt={image.description} />
      </div>
      <div className={cx('textColumn')}>
        {texts.map((text: ITextProps) => (
          <Text className={cx('text')} {...text} key={text.id} />
        ))}
      </div>
    </section>
  );
};
